import React from 'react';
import { useAtom } from 'jotai';
import { businessTypeAtom, visibleBusinessAtom } from '@/store';
import Modal from '../modal';
import BusinessCard from '@/assets/image/team/business-card.png';
import { BusinessType } from '@/constants/subscription';
import { useLocaleStore } from '@/i18n/localeStore';

import styles from './index.module.css';

const BusinessModal = () => {
  const { $t } = useLocaleStore();
  const [visibleBusiness, setVisibleBusiness] = useAtom(visibleBusinessAtom);
  const [businessType] = useAtom(businessTypeAtom);

  return (
    <Modal
      visible={visibleBusiness}
      onClose={() => setVisibleBusiness(false)}
      style={{
        width: '338px',
        height: '338px',
      }}
    >
      <div className={styles.body}>
        <div className={styles.title}>
          {businessType === BusinessType.LargeAmount
            ? $t((v) => v.Text_LargeOrderContact)
            : businessType === BusinessType.LargeSeats
            ? $t((v, { r }) => r(v.Text_LargeSeatsContact, [10]))
            : $t((v) => v.Text_ConsultEnterprise)}
        </div>
        <img src={BusinessCard} alt="" className={styles.img} />
      </div>
    </Modal>
  );
};

export default React.memo(BusinessModal);
